<div class="top-bar-content">
  <app-auth-header [title]="'Create Password'" [showMenu]="false"></app-auth-header>
</div>
<div class="auth-content">
  <form [formGroup]="passwordForm" (ngSubmit)="submitReset()" class="auth-form">
    <div class="subtext centered-with-padding">
      Create a new password for your eProve&trade; strategies account:
    </div>
    <label>Enter New Password</label>
    <div class="input-error-wrap">
      <input class="block" type="password" name="password" formControlName="password">
      <app-error-msg
        [control]="passwordForm.controls['password']"
        [show]="passwordForm.controls['password'].dirty && passwordForm.controls['password'].invalid">
      </app-error-msg>
    </div>
    <label>Re-enter Password</label>
    <div class="input-error-wrap last-one">
      <input class="block" type="password" name="confirmpassword" formControlName="confirmpassword">
      <app-error-msg
        [control]="passwordForm.controls['confirmpassword']"
        [show]="passwordForm.controls['confirmpassword'].dirty && passwordForm.controls['confirmpassword'].invalid">
      </app-error-msg>
    </div>
    <div class="subtext">
      Password must meet the following requirements:
      <ul class="password-rules">
        <li [ngClass]="{'error-msg-active': passwordForm.controls.password.dirty && !passwordValidator.noSpaces }">Cannot contain spaces</li>
        <li [ngClass]="{'error-msg-active': passwordForm.controls.password.dirty && !passwordValidator.eightChar }">Be at least 8 characters</li>
        <li [ngClass]="{'error-msg-active': passwordForm.controls.password.dirty && !passwordValidator.oneNumber}">At least one number</li>
        <li [ngClass]="{'error-msg-active': passwordForm.controls.password.dirty && !passwordValidator.oneLowercase}">At least one lowercase letter</li>
        <li [ngClass]="{'error-msg-active': passwordForm.controls.password.dirty && !passwordValidator.oneUppercase}">At least one uppercase letter</li>
        <li [ngClass]="{'error-msg-active': passwordForm.controls.password.dirty && !passwordValidator.oneSpecialChar}">At least one special character !@#$%^&()-_=+~`.*</li>
      </ul>
    </div>
    <button class="btn auth-btn no-style-when-disabled" type="submit" [disabled]="passwordForm.invalid || !passwordValidator.checkAllValidations()">Submit</button>
  </form>
  <app-footer-eprove-links></app-footer-eprove-links>
</div>
